import { API_ENDPOINTS } from '@/constants/api'
import { apiClient } from '@/lib/api/client'

const unwrapLog = (item) => {
  if (item?.data && !Array.isArray(item.data) && item.success !== undefined) {
    return item.data
  }
  return item
}

const normalizeListResponse = (response) => {
  const payload = response?.data
  const rawResults = Array.isArray(payload)
    ? payload
    : Array.isArray(payload?.results)
      ? payload.results
      : Array.isArray(payload?.data)
        ? payload.data
        : []
  const logs = rawResults.flatMap((item) => {
    if (Array.isArray(item?.data)) return item.data
    return [unwrapLog(item)]
  }).filter(Boolean)
  const totalCount = payload?.count
    ?? response?.meta?.pagination?.total_count
    ?? response?.meta?.total_count
    ?? logs.length

  return {
    data: logs,
    meta: {
      ...(response?.meta || {}),
      pagination: {
        total_count: totalCount,
        page: response?.meta?.page,
        page_size: response?.meta?.page_size,
      },
    },
  }
}

export const activityLogsApi = {
  getActivityLogs: async (params = {}) => {
    const response = await apiClient.get(API_ENDPOINTS.ACTIVITY_LOGS.LIST, { params })
    return normalizeListResponse(response)
  },

  getActivityLog: async (id) => {
    const response = await apiClient.get(
      API_ENDPOINTS.ACTIVITY_LOGS.DETAIL.replace(':id', id)
    )
    return response?.data?.data || response?.data || response
  },
}

export default activityLogsApi
